<div class="content-container h-full flex flex-col justify-between" #pageTop>
  <div>
    @if (isLoading()) {
      <lib-overlay-loader />
    }

    <header class="py-lg flex items-center">
      <h1 class="text-xl leading-7 font-semibold text-neutral-900">
        {{ pageTitle() }}
      </h1>
    </header>

    <form [formGroup]="userFormGroup()" libScrollToError>
      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 my-2xl">
          {{ 'user_form_screen_user_image_section_title' | transloco }}
        </h5>

        <div class="max-w-[23.8125rem]">
          <lib-upload-files
            [uploadedFiles]="uploadedImage()"
            [id]="'image'"
            [name]="'image'"
            [uploadUrl]="uploadFileUrls.upload"
            [removeUrl]="uploadFileUrls.remove"
            [label]="'project_form_screen_upload_image_label' | transloco"
            [inputFormControlName]="'image'"
            [accept]="'jpg,jpeg,png,webp'"
            [multiple]="false"
            [fileSizeLimit]="2048 * 1000"
            [viewOnly]="false"
            [required]="false"
            [uploadedFileLimit]="1"
            [uploadFileLabels]="{
              placeholder: 'upload_files_placeholder' | transloco,
              singleFileAttachedLabel:
                'upload_files_single_file_attached_label' | transloco,
              multipleFilesAttachedLabel:
                'upload_files_multiple_files_attached_label' | transloco,
              addMoreLabel: 'upload_files_add_more_label' | transloco,
              attachmentsTitle: 'upload_files_attachments_title' | transloco,
              fileUploadTitle: 'upload_files_file_upload_title' | transloco,
              dragAndDropLabel: 'upload_files_drag_and_drop_label' | transloco,
              orLabel: 'upload_files_or_label' | transloco,
              uploadFromComputerLabel:
                'upload_files_upload_from_computer_label' | transloco,
              maxSizeLabel: 'upload_files_max_size_label' | transloco,
              perFileLabel: 'upload_files_per_file_label' | transloco,
              maxFilesLimitLabel:
                'upload_files_max_files_limit_label' | transloco,
              cancelButtonLabel: 'upload_files_cancel_button_label' | transloco,
              continueButtonLabel:
                'upload_files_continue_button_label' | transloco,
              singleFileUploadedLabel:
                'upload_files_single_file_uploaded_label' | transloco,
              multipleFilesUploadedLabel:
                'upload_files_multiple_files_uploaded_label' | transloco,
              singleFileLabel: 'upload_files_single_file_label' | transloco,
              multipleFilesLabel:
                'upload_files_multiple_files_label' | transloco,
              allFormatsAcceptedLabel:
                'upload_files_all_formats_accepted_label' | transloco,
              acceptedFormatLabel:
                'upload_files_accepted_format_label' | transloco,
              acceptedFormatsLabel:
                'upload_files_accepted_formats_label' | transloco,
              uploadedLabel: 'upload_files_uploaded_label' | transloco,
              deleteWarningPopupTitle:
                'upload_image_warning_popup_title' | transloco,
              deleteWarningPopupDeclaimerMessage:
                'upload_image_warning_popup_declaimer_message' | transloco,
              deleteWarningPopupCancelButton:
                'upload_image_warning_popup_cancel_button' | transloco,
              deleteWarningPopupContinueButton:
                'upload_image_warning_popup_delete_button' | transloco,
            }" />
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="image" />
        </div>
      </section>

      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 my-2xl">
          {{ 'user_form_screen_user_info_section_title' | transloco }}
        </h5>

        <div
          class="max-w-[48.75rem] grid [grid-template-columns:repeat(auto-fill,minmax(18.75rem,1fr))] gap-lg">
          <div>
            <div formGroupName="first_name">
              <dual-lang-input
                [requiredGroup]="true"
                [inputFormControlName]="'first_name'"
                [id]="'first_name'"
                type="text"
                name="first_name"
                [requiredEn]="false"
                [requiredAr]="false"
                [label]="'user_form_screen_first_name_label' | transloco"
                [placeholderEn]="
                  'user_form_screen_first_name_placeholder_en' | transloco
                "
                [placeholderAr]="
                  'user_form_screen_first_name_placeholder_ar' | transloco
                " />
            </div>
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="first_name" />
          </div>

          <div>
            <div formGroupName="last_name">
              <dual-lang-input
                [requiredGroup]="true"
                [inputFormControlName]="'last_name'"
                [id]="'last_name'"
                type="text"
                name="last_name"
                [requiredEn]="false"
                [requiredAr]="false"
                [label]="'user_form_screen_last_name_label' | transloco"
                [placeholderEn]="
                  'user_form_screen_last_name_placeholder_en' | transloco
                "
                [placeholderAr]="
                  'user_form_screen_last_name_placeholder_ar' | transloco
                " />
            </div>
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="last_name" />
          </div>

          <div>
            <lib-mobile-input
              [inputFormControlName]="'phone'"
              [id]="'phone'"
              [name]="'phone'"
              [label]="'user_form_screen_phone_number_label' | transloco"
              [required]="true"
              [searchPlaceholder]="
                'phone_number_search_placeholder' | transloco
              "
              [selectedCountry]="selectedCountryISO()"
              [selectedPhoneNumber]="selectedPhoneNumber()" />

            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="phone"
              [customErrorMessages]="{
                pattern:
                  'user_form_screen_phone_number_pattern_error_message'
                  | transloco,
              }" />
          </div>

          <div>
            <lib-input
              [inputFormControlName]="'email'"
              [id]="'email'"
              type="email"
              name="email"
              [required]="true"
              [label]="'user_form_screen_email_address_label' | transloco"
              [disabled]="emailDisabled()"
              [placeholder]="'email_input_default_placeholder' | transloco" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="email" />
          </div>

          <div>
            <lib-input
              [inputFormControlName]="'identifier'"
              [id]="'identifier'"
              type="text"
              name="identifier"
              [label]="'user_form_screen_employee_id_label' | transloco"
              [placeholder]="'id_input_default_placeholder' | transloco" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="identifier" />
          </div>
        </div>
      </section>

      <lib-user-work-info-form-section
        [formGroup]="userFormGroup()"
        [userId]="userId()"
        [legalEntity]="legalEntity()"
        [department]="department()"
        [directManager]="directManager()"
        [selectedDepartment]="selectedDepartment()"
        [selectedDirectManager]="selectedDirectManager()"
        [selectedJobTitle]="selectedJobTitle()"
        [selectedPosition]="selectedPosition()"
        [userDetails]="userData()" />
    </form>
  </div>

  <div class="mt-5xl">
    <div
      class="flex items-center justify-between border-b border-neutral-200 pb-lg">
      <div class="flex items-center gap-lg">
        <h6 class="font-semibold text-lg text-neutral-900">
          {{ 'user_form_screen_groups_info_section_title' | transloco }}
        </h6>
      </div>

      <div>
        <button
          (click)="openAssignGroupUsersDialog()"
          id="user_form_screen_assign_button"
          type="button"
          class="bg-primary-500 text-white font-medium text-sm py-sm px-lg border-none rounded-md gap-sm flex items-center">
          <lib-add-icon [iconClass]="'size-5 text-white'" />

          {{ 'user_form_screen_assign_button' | transloco }}
        </button>
      </div>
    </div>

    <div class="my-lg">
      @if (isAssignedListLoading()) {
        <div class="flex justify-center items-center h-full my-4xl">
          <lib-loader />
        </div>
      } @else {
        <lib-group-user-card
          [list]="assignedList()"
          [itemType]="'Group'"
          [mode]="'edit'"
          (unselectGroupUser)="removeAssignedItem($event)" />
      }

      @if (
        (assignedList().length || assignedListCurrentPage() > 1) && userId()
      ) {
        <div class="mt-2xl">
          <lib-paginator
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="assignedListCurrentPage()"
            [totalPages]="assignedListTotalPages()"
            [totalItems]="assignedListTotal()"
            [currentSize]="15"
            (goTo)="handleAssignedListPagination($event)"
            (next)="handleAssignedListPagination($event)"
            (previous)="handleAssignedListPagination($event)" />
        </div>
      }
    </div>
  </div>

  <footer class="flex justify-end items-end pb-2xl">
    <div class="flex justify-end gap-lg mt-2xl">
      <a
        id="cancel"
        class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium cursor-pointer"
        [routerLink]="[
          editMode()
            ? (`${ADMIN_ROUTES.USERS_DATABASE.DETAILS}/${userId()}`
              | tenantPath: 'admin')
            : (`${ADMIN_ROUTES.USERS_DATABASE.LIST}` | tenantPath: 'admin'),
        ]">
        {{ 'user_form_screen_cancel_button' | transloco }}
      </a>

      <button
        id="submit"
        class="bg-primary-500 px-2xl py-sm rounded-md text-white text-base min-w-[7.1875rem]"
        (click)="submit()"
        [class.opacity-30]="isLoading()"
        [disabled]="isLoading()">
        {{ buttonText() }}
      </button>
    </div>
  </footer>
</div>

<ng-template #assignGroupUsersDialog>
  <lib-assign-group-users
    [groupUsersCards]="lookupList()"
    [selectedGroupUsersCards]="selectedList()"
    (selectGroupUser)="selectItem($event)"
    (unselectGroupUser)="removeSelectedItem($event)"
    (saveAssignedGroupUsers)="saveAssignedItems()"
    (filterGroupUsersCards)="getGroupUsers($event)"
    (paginateGroupUsersCards)="getGroupUsers('', $event)"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    [itemType]="'Group'" />
</ng-template>

<ng-template #addUser>
  <div class="flex justify-center">
    <div
      class="flex justify-center items-center bg-primary-50 p-lg rounded-full mb-xl">
      <lib-mail-icon iconClass="size-8 text-primary-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'add_user_form_reinvite_pop_up_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center">
    {{ 'add_user_form_reinvite_pop_up_content' | transloco }}
  </p>
  <p class="text-sm text-primary-500 text-center mb-4xl">
    {{ this.userFormGroup().get('email')?.value }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      (click)="addDraftUser('pending')"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'add_user_form_reinvite_pop_up_send_invitation_label' | transloco }}
    </button>

    <button
      (click)="addDraftUser('draft')"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'add_user_form_reinvite_pop_up_save_as_draft_label' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #externalUserChange>
  <div class="flex justify-center">
    <div
      class="flex justify-center items-center bg-warning-50 p-lg rounded-full mb-xl">
      <lib-warning-icon iconClass="size-8 text-warning-500" />
    </div>
  </div>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ externalUserChangeMessage() | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      (click)="confirmExternalUserChange()"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'user_form_screen_external_user_change_confirm_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'user_form_screen_external_user_change_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>
